import { render, staticRenderFns } from "./dataProcessingModal.vue?vue&type=template&id=b2ae6e3a&scoped=true"
import script from "./dataProcessingModal.vue?vue&type=script&lang=js"
export * from "./dataProcessingModal.vue?vue&type=script&lang=js"
import style0 from "./dataProcessingModal.vue?vue&type=style&index=0&id=b2ae6e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ae6e3a",
  null
  
)

export default component.exports